import { useState } from "react";
import Report from "./FullReport";
import { Button , Spinner} from "reactstrap";
import {Spin as AntSpinner} from "antd";

const ReportSelector = ({ data }) => {
  const [type, setType] = useState("small");
  const [loader, setLoader] = useState(null);

  const handleSelect = (selectedType) => {
    setLoader(selectedType);

    setTimeout(() => {
      setType(selectedType);
      setLoader(null);
    }, 600);
  };

  const getButtonColor = (btnType) => {
    if (loader === btnType) return "success";
    if (type === btnType) return "success";
    return "primary";
  };

  const showFullLoader = loader !== null;

  return (
    <>
      {showFullLoader && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "80%",
            height: "100%",
            marginLeft: "260px",
            background: "rgba(255, 255, 255, 0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backdropFilter: "blur(6px)",
            zIndex: 9999,
          }}
        >
          <AntSpinner style={{ width: "3rem", height: "3rem" }} />
        </div>
      )}

      <div className={showFullLoader ? "blur-background" : ""}>
        <Button
          color={getButtonColor("small")}
          className="select-box"
          disabled={loader !== null}
          onClick={() => handleSelect("small")}
        >
          {loader === "small" ? <Spinner size="sm" className="me-2" /> : ""} 
          Small Report
        </Button>

        <Button
          color={getButtonColor("medium")}
          className="select-box mx-2"
          disabled={loader !== null}
          onClick={() => handleSelect("medium")}
        >
          {loader === "medium" ? <Spinner size="sm" className="me-2" /> : ""} 
          Medium Report
        </Button>

        <Button
          color={getButtonColor("full")}
          className="select-box"
          disabled={loader !== null}
          onClick={() => handleSelect("full")}
        >
          {loader === "full" ? <Spinner size="sm" className="me-2" /> : ""} 
          Full Report
        </Button>

        <Report data={data} type={type} />
      </div>

      <style>{`
        .blur-background {
          filter: blur(3px);
          pointer-events: none;
          user-select: none;
        }
      `}</style>
    </>
  );
};

export default ReportSelector;